const STORAGE_KEY = "finDocSitRecords";
const CONFIG_KEY = "finDocSitConfig";
const STORAGE_VERSION_KEY = "finDocSitRecordsVersion";
const STORAGE_VERSION = "20260609-finance-graph-chain";

export const FIN_DOC_SIT_USERS = [
  { key: "user1", label: "一般同仁 Howard", name: "Howard Chou", email: "howard.chou@wiadvance.com", role: "user" },
  { key: "user2", label: "一般同仁 Allen", name: "Allen Wu", email: "allen.wu@wiadvance.com", role: "user" },
  { key: "user3", label: "一般同仁 Vivian", name: "Vivian Lin", email: "vivian.lin@wiadvance.com", role: "user" },
  { key: "finance1", label: "財務 Kaia", name: "Kaia Chen", email: "kaia.chen@wiadvance.com", role: "finance" },
  { key: "finance2", label: "財務 Sara", name: "Sara Yu", email: "sara.yu@wiadvance.com", role: "finance" },
  { key: "finance3", label: "財務 Stephanie", name: "Stephanie Chen", email: "stephanie.chen@wiadvance.com", role: "finance" },
  { key: "michael", label: "總經理", name: "總經理", email: "michael.hsia@wiadvance.com", role: "michael" },
];

const MICHAEL = { name: "總經理", email: "michael.hsia@wiadvance.com" };
const FINANCE_GROUP = [
  { name: "Kaia Chen", email: "kaia.chen@wiadvance.com" },
  { name: "Sara Yu", email: "sara.yu@wiadvance.com" },
  { name: "Stephanie Chen", email: "stephanie.chen@wiadvance.com" },
];

const now = () => Date.now();

const clone = (value) => JSON.parse(JSON.stringify(value));

const buildPageResult = (rows, page, pageSize) => {
  const currentPage = Number(page || 1);
  const currentPageSize = Number(pageSize || 10);
  const startIndex = (currentPage - 1) * currentPageSize;
  const pagedRows = rows.slice(startIndex, startIndex + currentPageSize);

  return {
    isSuccess: true,
    data: pagedRows,
    pageCounts: rows.length,
  };
};

const matchesStatus = (record, statuses) => {
  if (!statuses || statuses.length === 0) {
    return true;
  }

  return statuses.includes(record.findoc_status);
};

const matchesKeywordFilters = (record, filter) => {
  const applicantKeyword = (filter?.applicant_name || "").trim().toLowerCase();
  if (applicantKeyword && !record.applicant_name?.toLowerCase().includes(applicantKeyword)) {
    return false;
  }

  if (filter?.findoc_no && Number(filter.findoc_no) !== Number(record.findoc_no)) {
    return false;
  }

  if (filter?.company && filter.company !== record.company) {
    return false;
  }

  if (filter?.start_date && Number(record.cr_date) < Number(filter.start_date)) {
    return false;
  }

  if (filter?.end_date && Number(record.cr_date) > Number(filter.end_date)) {
    return false;
  }

  if (filter?.next_auditor_mail) {
    const normalizedAuditor = String(filter.next_auditor_mail).toLowerCase();
    const currentAuditors = String(record.next_auditor_mail || "").toLowerCase();
    if (!currentAuditors.includes(normalizedAuditor)) {
      return false;
    }
  }

  return true;
};

// 正式環境完全不提供模擬(SIT)流程與設定
export const IS_FINDOC_SIT_ALLOWED = process.env.REACT_APP_ENV !== "production";

const getSitConfig = () => {
  if (!IS_FINDOC_SIT_ALLOWED) {
    return { enabled: false, userKey: "finance1" };
  }
  try {
    const config = JSON.parse(localStorage.getItem(CONFIG_KEY) || "{}");
    const validUserKey = FIN_DOC_SIT_USERS.some((user) => user.key === config.userKey) ? config.userKey : "finance1";
    return {
      enabled: config.enabled === true,
      userKey: validUserKey,
    };
  } catch {
    return { enabled: false, userKey: "finance1" };
  }
};

export const getFinDocSitConfig = () => getSitConfig();

export const getFinDocSitActor = () => {
  const config = getSitConfig();
  return FIN_DOC_SIT_USERS.find((user) => user.key === config.userKey) || FIN_DOC_SIT_USERS[0];
};

const seedRecords = () => {
  const seedTime = now();
  return [
    {
      findoc_no: 1001,
      applicant_name: "Kaia Chen",
      applicant_mail: "kaia.chen@wiadvance.com",
      is_agent: "N",
      agent_name: "",
      agent_mail: "",
      company: "WIA",
      apply_reason: "投標文件使用",
      next_auditor_name: "Stephanie Chen",
      next_auditor_mail: "stephanie.chen@wiadvance.com",
      findoc_status: "pendingAudit",
      file_url: ["mock://1001-req.pdf"],
      upload_file_url: [],
      cr_date: seedTime - 1000 * 60 * 60 * 24 * 2,
      cr_user: "kaia.chen@wiadvance.com",
      upd_date: seedTime - 1000 * 60 * 60 * 24 * 2,
      upd_user: "kaia.chen@wiadvance.com",
      doc_items: [
        {
          id: 1,
          findoc_no: 1001,
          doc_type: "financialReport",
          period_start: "2026-03",
          period_end: "2026-03",
          need_original: "N",
          remark: "請提供電子檔",
          cr_date: seedTime - 1000 * 60 * 60 * 24 * 2,
        },
      ],
      audit_logs: [],
    },
    {
      findoc_no: 1002,
      applicant_name: "Sara Yu",
      applicant_mail: "sara.yu@wiadvance.com",
      is_agent: "N",
      agent_name: "",
      agent_mail: "",
      company: "WIT",
      apply_reason: "客戶查核附件",
      next_auditor_name: MICHAEL.name,
      next_auditor_mail: MICHAEL.email,
      findoc_status: "pendingMgr",
      file_url: ["mock://1002-req.pdf"],
      upload_file_url: [],
      cr_date: seedTime - 1000 * 60 * 60 * 24 * 4,
      cr_user: "sara.yu@wiadvance.com",
      upd_date: seedTime - 1000 * 60 * 60 * 24 * 3,
      upd_user: "stephanie.chen@wiadvance.com",
      doc_items: [
        {
          id: 2,
          findoc_no: 1002,
          doc_type: "tax401Cert",
          period_start: "2026-01",
          period_end: "2026-03",
          need_original: "Y",
          remark: "寄送正本",
          cr_date: seedTime - 1000 * 60 * 60 * 24 * 4,
        },
      ],
      audit_logs: [
        {
          id: 1,
          findoc_no: 1002,
          auditor_name: "Stephanie Chen",
          auditor_mail: "stephanie.chen@wiadvance.com",
          audit_date: seedTime - 1000 * 60 * 60 * 24 * 3,
          audit_status: "auditAgree",
          audit_command: "送總經理確認",
          auditor_type: "上級主管",
        },
      ],
    },
    {
      findoc_no: 1003,
      applicant_name: "Stephanie Chen",
      applicant_mail: "stephanie.chen@wiadvance.com",
      is_agent: "N",
      agent_name: "",
      agent_mail: "",
      company: "WIA",
      apply_reason: "年度審計",
      next_auditor_name: FINANCE_GROUP.map((item) => item.name).join(","),
      next_auditor_mail: FINANCE_GROUP.map((item) => item.email).join(","),
      findoc_status: "pendingFinance",
      file_url: ["mock://1003-req.pdf"],
      upload_file_url: [],
      cr_date: seedTime - 1000 * 60 * 60 * 24 * 6,
      cr_user: "stephanie.chen@wiadvance.com",
      upd_date: seedTime - 1000 * 60 * 60 * 24 * 1,
      upd_user: MICHAEL.email,
      doc_items: [
        {
          id: 3,
          findoc_no: 1003,
          doc_type: "companyRegForm",
          period_start: "",
          period_end: "",
          need_original: "N",
          remark: "",
          cr_date: seedTime - 1000 * 60 * 60 * 24 * 6,
        },
      ],
      audit_logs: [
        {
          id: 2,
          findoc_no: 1003,
          auditor_name: "Stephanie Chen",
          auditor_mail: "stephanie.chen@wiadvance.com",
          audit_date: seedTime - 1000 * 60 * 60 * 24 * 5,
          audit_status: "auditAgree",
          audit_command: "",
          auditor_type: "上級主管",
        },
        {
          id: 3,
          findoc_no: 1003,
          auditor_name: MICHAEL.name,
          auditor_mail: MICHAEL.email,
          audit_date: seedTime - 1000 * 60 * 60 * 24 * 1,
          audit_status: "auditAgree",
          audit_command: "請財務協助",
          auditor_type: "Michael",
        },
      ],
    },
    {
      findoc_no: 1004,
      applicant_name: "Kaia Chen",
      applicant_mail: "kaia.chen@wiadvance.com",
      is_agent: "N",
      agent_name: "",
      agent_mail: "",
      company: "WIT",
      apply_reason: "已完成樣本",
      next_auditor_name: "",
      next_auditor_mail: "",
      findoc_status: "done",
      file_url: ["mock://1004-req.pdf"],
      upload_file_url: ["mock://1004-result.pdf"],
      cr_date: seedTime - 1000 * 60 * 60 * 24 * 12,
      done_by_name: "Sara Yu",
      done_by_mail: "sara.yu@wiadvance.com",
      done_date: seedTime - 1000 * 60 * 60 * 24 * 8,
      cr_user: "kaia.chen@wiadvance.com",
      upd_date: seedTime - 1000 * 60 * 60 * 24 * 8,
      upd_user: "kaia.chen@wiadvance.com",
      doc_items: [
        {
          id: 4,
          findoc_no: 1004,
          doc_type: "noBounceCert",
          period_start: "2025-01",
          period_end: "2025-12",
          need_original: "N",
          remark: "",
          cr_date: seedTime - 1000 * 60 * 60 * 24 * 12,
        },
      ],
      audit_logs: [
        {
          id: 4,
          findoc_no: 1004,
          auditor_name: "Stephanie Chen",
          auditor_mail: "stephanie.chen@wiadvance.com",
          audit_date: seedTime - 1000 * 60 * 60 * 24 * 11,
          audit_status: "auditAgree",
          audit_command: "",
          auditor_type: "上級主管",
        },
        {
          id: 5,
          findoc_no: 1004,
          auditor_name: MICHAEL.name,
          auditor_mail: MICHAEL.email,
          audit_date: seedTime - 1000 * 60 * 60 * 24 * 10,
          audit_status: "auditAgree",
          audit_command: "",
          auditor_type: "Michael",
        },
        {
          id: 6,
          findoc_no: 1004,
          auditor_name: "Sara Yu",
          auditor_mail: "sara.yu@wiadvance.com",
          audit_date: seedTime - 1000 * 60 * 60 * 24 * 8,
          audit_status: "upload",
          audit_command: "已備妥",
          auditor_type: "財務同仁",
        },
      ],
    },
    {
      findoc_no: 1005,
      applicant_name: "Sara Yu",
      applicant_mail: "sara.yu@wiadvance.com",
      is_agent: "N",
      agent_name: "",
      agent_mail: "",
      company: "WIA",
      apply_reason: "被駁回樣本",
      next_auditor_name: "",
      next_auditor_mail: "",
      findoc_status: "reject",
      file_url: ["mock://1005-req.pdf"],
      upload_file_url: [],
      cr_date: seedTime - 1000 * 60 * 60 * 24 * 9,
      cr_user: "sara.yu@wiadvance.com",
      upd_date: seedTime - 1000 * 60 * 60 * 24 * 7,
      upd_user: MICHAEL.email,
      doc_items: [
        {
          id: 5,
          findoc_no: 1005,
          doc_type: "otherFinDoc",
          period_start: "",
          period_end: "",
          need_original: "N",
          remark: "補件不足",
          cr_date: seedTime - 1000 * 60 * 60 * 24 * 9,
        },
      ],
      audit_logs: [
        {
          id: 7,
          findoc_no: 1005,
          auditor_name: "Stephanie Chen",
          auditor_mail: "stephanie.chen@wiadvance.com",
          audit_date: seedTime - 1000 * 60 * 60 * 24 * 8,
          audit_status: "auditAgree",
          audit_command: "",
          auditor_type: "上級主管",
        },
        {
          id: 8,
          findoc_no: 1005,
          auditor_name: MICHAEL.name,
          auditor_mail: MICHAEL.email,
          audit_date: seedTime - 1000 * 60 * 60 * 24 * 7,
          audit_status: "auditReject",
          audit_command: "請補上用途說明",
          auditor_type: "Michael",
        },
      ],
    },
  ];
};

const readRecords = () => {
  try {
    if (localStorage.getItem(STORAGE_VERSION_KEY) !== STORAGE_VERSION) {
      throw new Error("FinDoc SIT seed version changed");
    }

    const records = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    if (Array.isArray(records) && records.length > 0) {
      return records;
    }
  } catch {
    // ignore malformed local data and reseed below
  }

  const seeded = seedRecords();
  localStorage.setItem(STORAGE_KEY, JSON.stringify(seeded));
  localStorage.setItem(STORAGE_VERSION_KEY, STORAGE_VERSION);
  return seeded;
};

const writeRecords = (records) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
};

export const resetFinDocSitRecords = () => {
  const seeded = seedRecords();
  writeRecords(seeded);
  localStorage.setItem(STORAGE_VERSION_KEY, STORAGE_VERSION);
  return seeded;
};

const sortByNewest = (records) => clone(records).sort((left, right) => Number(right.findoc_no) - Number(left.findoc_no));

const currentActor = () => getFinDocSitActor();

const nextLogId = (records) => {
  const allLogs = records.flatMap((record) => record.audit_logs || []);
  const maxId = allLogs.reduce((max, item) => Math.max(max, Number(item.id || 0)), 0);
  return maxId + 1;
};

const attachLog = (records, findocNo, logEntry) => {
  const record = records.find((item) => Number(item.findoc_no) === Number(findocNo));
  if (!record) {
    return;
  }

  record.audit_logs = [...(record.audit_logs || []), logEntry];
};

export const mockGetFinDocMenus = async () => {
  const actor = currentActor();
  const records = readRecords();
  const lowerMail = actor.email.toLowerCase();

  const data = [
    {
      menu: "application",
      count: records.filter((record) => ["pendingAudit", "pendingMgr", "pendingFinance"].includes(record.findoc_status) &&
        [record.applicant_mail, record.agent_mail].filter(Boolean).some((mail) => String(mail).toLowerCase() === lowerMail)).length,
    },
    {
      menu: "history",
      count: records.filter((record) => ["done", "reject", "cancel"].includes(record.findoc_status) &&
        [record.applicant_mail, record.agent_mail].filter(Boolean).some((mail) => String(mail).toLowerCase() === lowerMail)).length,
    },
    {
      menu: "pending_audit",
      count: records.filter((record) => ["pendingAudit", "pendingMgr"].includes(record.findoc_status) && String(record.next_auditor_mail || "").toLowerCase().includes(lowerMail)).length,
    },
    {
      menu: "audited",
      count: records.filter((record) => (record.audit_logs || []).some((log) => String(log.auditor_mail).toLowerCase() === lowerMail)).length,
    },
    {
      menu: "pending_finance",
      count: records.filter((record) => record.findoc_status === "pendingFinance" && String(record.next_auditor_mail || "").toLowerCase().includes(lowerMail)).length,
    },
    {
      menu: "archived",
      count: actor.role === "finance" ? records.filter((record) => record.findoc_status === "done").length : 0,
    },
  ];

  return { isSuccess: true, data };
};

export const mockQueryFinDoc = async (filter = {}) => {
  const actor = currentActor();
  const lowerMail = actor.email.toLowerCase();
  const records = sortByNewest(readRecords()).filter((record) => {
    const matchedOwner = !filter?.next_auditor_mail
      ? [record.applicant_mail, record.agent_mail].filter(Boolean).some((mail) => String(mail).toLowerCase() === lowerMail)
      : true;

    return matchedOwner && matchesStatus(record, filter.findoc_status) && matchesKeywordFilters(record, filter);
  });

  return buildPageResult(records, filter.page, filter.page_record_set);
};

export const mockQueryIsAuditFinDoc = async (filter = {}) => {
  const actor = currentActor();
  const lowerMail = actor.email.toLowerCase();
  const records = sortByNewest(readRecords()).filter((record) => {
    const auditedByMe = (record.audit_logs || []).some((log) => String(log.auditor_mail).toLowerCase() === lowerMail);
    return auditedByMe && matchesKeywordFilters(record, filter);
  });

  return buildPageResult(records, filter.page, filter.page_record_set);
};

export const mockQueryArchivedFinDoc = async (filter = {}) => {
  const actor = currentActor();
  if (actor.role !== "finance") {
    return buildPageResult([], filter.page, filter.page_record_set);
  }

  const records = sortByNewest(readRecords()).filter((record) => record.findoc_status === "done" && matchesKeywordFilters(record, filter));
  return buildPageResult(records, filter.page, filter.page_record_set);
};

export const mockGetFinDocDetail = async (findocNo) => {
  const records = readRecords();
  const record = records.find((item) => Number(item.findoc_no) === Number(findocNo));
  return { isSuccess: !!record, data: record ? [clone(record)] : [] };
};

export const mockQueryFinDocLog = async (findocNo) => {
  const records = readRecords();
  const record = records.find((item) => Number(item.findoc_no) === Number(findocNo));
  return { isSuccess: !!record, data: clone(record?.audit_logs || []) };
};

export const mockAddFinDoc = async (payload) => {
  const actor = currentActor();
  const records = readRecords();
  const newNo = records.reduce((max, item) => Math.max(max, Number(item.findoc_no)), 1000) + 1;
  const createdAt = now();

  records.push({
    findoc_no: newNo,
    applicant_name: payload.applicant_name || actor.name,
    applicant_mail: payload.applicant_mail || actor.email,
    is_agent: payload.is_agent || "N",
    agent_name: payload.agent_name || "",
    agent_mail: payload.agent_mail || "",
    company: payload.company,
    apply_reason: payload.apply_reason || "",
    next_auditor_name: payload.next_auditor_name || MICHAEL.name,
    next_auditor_mail: payload.next_auditor_mail || MICHAEL.email,
    findoc_status: String(payload.next_auditor_mail || MICHAEL.email).toLowerCase() === MICHAEL.email.toLowerCase() ? "pendingMgr" : "pendingAudit",
    file_url: clone(payload.file || []),
    upload_file_url: [],
    cr_date: createdAt,
    cr_user: payload.applicant_mail || actor.email,
    upd_date: createdAt,
    upd_user: payload.applicant_mail || actor.email,
    doc_items: (payload.doc_items || []).map((item, index) => ({
      id: createdAt + index,
      findoc_no: newNo,
      doc_type: item.doc_type,
      period_start: item.period_start || "",
      period_end: item.period_end || "",
      need_original: item.need_original || "N",
      remark: item.remark || "",
      cr_date: createdAt,
    })),
    audit_logs: [],
  });

  writeRecords(records);

  return { isSuccess: true, data: true, findoc_no: newNo };
};

export const mockCancelFinDoc = async (findocNo) => {
  const actor = currentActor();
  const records = readRecords();
  const record = records.find((item) => Number(item.findoc_no) === Number(findocNo));
  if (!record) {
    return { isSuccess: false, errorMessage: "查無資料" };
  }

  record.findoc_status = "cancel";
  record.next_auditor_name = "";
  record.next_auditor_mail = "";
  record.upd_date = now();
  record.upd_user = actor.email;
  attachLog(records, findocNo, {
    id: nextLogId(records),
    findoc_no: Number(findocNo),
    auditor_name: actor.name,
    auditor_mail: actor.email,
    audit_date: now(),
    audit_status: "cancel",
    audit_command: "申請人取消",
    auditor_type: "申請人",
  });
  writeRecords(records);

  return { isSuccess: true, data: true };
};

export const mockAgreeFinDoc = async (payload) => {
  const records = readRecords();
  const record = records.find((item) => Number(item.findoc_no) === Number(payload.findoc_no));
  if (!record) {
    return { isSuccess: false, errorMessage: "查無資料" };
  }

  record.findoc_status = payload.next_auditor_mail?.toLowerCase() === MICHAEL.email ? "pendingMgr" : "pendingAudit";
  record.next_auditor_name = payload.next_auditor_name || MICHAEL.name;
  record.next_auditor_mail = payload.next_auditor_mail || MICHAEL.email;
  record.upd_date = now();
  record.upd_user = payload.auditor_mail;

  attachLog(records, payload.findoc_no, {
    id: nextLogId(records),
    findoc_no: Number(payload.findoc_no),
    auditor_name: payload.auditor_name,
    auditor_mail: payload.auditor_mail,
    audit_date: now(),
    audit_status: "auditAgree",
    audit_command: payload.audit_command || "",
    auditor_type: payload.auditor_type || "上級主管",
  });
  writeRecords(records);

  return { isSuccess: true, data: true };
};

export const mockMgrAgreeFinDoc = async (payload) => {
  const records = readRecords();
  const record = records.find((item) => Number(item.findoc_no) === Number(payload.findoc_no));
  if (!record) {
    return { isSuccess: false, errorMessage: "查無資料" };
  }

  record.findoc_status = "pendingFinance";
  record.next_auditor_name = payload.next_auditor_name || FINANCE_GROUP.map((item) => item.name).join(",");
  record.next_auditor_mail = payload.next_auditor_mail || FINANCE_GROUP.map((item) => item.email).join(",");
  record.upd_date = now();
  record.upd_user = payload.auditor_mail;

  attachLog(records, payload.findoc_no, {
    id: nextLogId(records),
    findoc_no: Number(payload.findoc_no),
    auditor_name: payload.auditor_name,
    auditor_mail: payload.auditor_mail,
    audit_date: now(),
    audit_status: "auditAgree",
    audit_command: payload.audit_command || "",
    auditor_type: payload.auditor_type || "Michael",
  });
  writeRecords(records);

  return { isSuccess: true, data: true };
};

export const mockRejectFinDoc = async (payload) => {
  const records = readRecords();
  const record = records.find((item) => Number(item.findoc_no) === Number(payload.findoc_no));
  if (!record) {
    return { isSuccess: false, errorMessage: "查無資料" };
  }

  record.findoc_status = "reject";
  record.next_auditor_name = "";
  record.next_auditor_mail = "";
  record.upd_date = now();
  record.upd_user = payload.auditor_mail;

  attachLog(records, payload.findoc_no, {
    id: nextLogId(records),
    findoc_no: Number(payload.findoc_no),
    auditor_name: payload.auditor_name,
    auditor_mail: payload.auditor_mail,
    audit_date: now(),
    audit_status: "auditReject",
    audit_command: payload.audit_command || "",
    auditor_type: payload.auditor_type || "上級主管",
  });
  writeRecords(records);

  return { isSuccess: true, data: true };
};

export const mockMgrRejectFinDoc = mockRejectFinDoc;

export const mockFinanceUploadFinDoc = async (payload) => {
  const records = readRecords();
  const record = records.find((item) => Number(item.findoc_no) === Number(payload.findoc_no));
  if (!record) {
    return { isSuccess: false, errorMessage: "查無資料" };
  }

  record.findoc_status = "done";
  record.upload_file_url = clone(payload.upload_file_url || []);
  record.done_by_name = payload.auditor_name;
  record.done_by_mail = payload.auditor_mail;
  record.done_date = now();
  record.next_auditor_name = "";
  record.next_auditor_mail = "";
  record.upd_date = now();
  record.upd_user = payload.auditor_mail;

  attachLog(records, payload.findoc_no, {
    id: nextLogId(records),
    findoc_no: Number(payload.findoc_no),
    auditor_name: payload.auditor_name,
    auditor_mail: payload.auditor_mail,
    audit_date: now(),
    audit_status: "upload",
    audit_command: payload.audit_command || "",
    auditor_type: "財務同仁",
  });
  writeRecords(records);

  return { isSuccess: true, data: true };
};
